import { type context_engine } from "@dropbox/api-v2-client/types";
import { type AvailableModels, type ModelInfo, ModelSource } from "../types";

export const convertToAvailableModels = (
  response: context_engine.ListAvailableModelsResponse,
): AvailableModels => {
  return {
    models: (response.models || []).map(convertModelInfo),
  };
};

export const convertModelSource = (
  source: context_engine.ModelSource,
): ModelSource => {
  switch (source[".tag"]) {
    case "model_source_azure":
      return ModelSource.AZURE;
    case "model_source_bedrock":
      return ModelSource.BEDROCK;
    case "model_source_groq":
      return ModelSource.GROQ;
    case "model_source_openai":
      return ModelSource.OPENAI;
    case "model_source_vertex_ai":
      return ModelSource.VERTEX_AI;
    case "model_source_dropbox":
      return ModelSource.DROPBOX;
    default:
      return ModelSource.UNKNOWN;
  }
};

const convertModelInfo = (model: context_engine.ModelInfo): ModelInfo => {
  return {
    id: model.id!,
    displayName: model.display_name!,
    description: model.description!,
    isCertified: model.is_certified!,
    modelSource: convertModelSource(model.model_source!),
  };
};
